import { addToCart, updateCartGift, updateCart, ajaxCart } from './ajax-cart';
const $doc = $(document);

/* Remove Item From Cart */
$doc.on('click', '.js-cart-remove', function(e) {
  e.preventDefault();
  const $this = $(this);
  const $itemsParent = $this.closest('.js-cart-items');

  if ($itemsParent.length) {
    const $rows = $itemsParent.find('[data-prop-target]');
    let rowsArr = [];
    const propParent = $this.closest('[data-prop]').data('prop')
    const $propTarget = $this.closest('[data-prop-target]');
    let propTarget;

    if ($propTarget.length) {
      propTarget = $propTarget.data('prop-target');
    };

    $rows.each(function() {
      const $row = $(this);
      let rowQuantity = $row.find('.js-qty input').val();
      const dataProp = $row.data('prop');
      const dataTarget = $row.data('prop-target');

      if ((dataProp != '' && dataProp === `${propParent}`) || (dataTarget != '' && dataTarget === `${propTarget}`) || (dataProp != '' && dataProp === `${propTarget}`)) {
        rowQuantity = 0;
      }

      rowsArr.push(rowQuantity);
    });

    if ($this.closest('.js-widget-cart').length) {
      updateCartGift(rowsArr, true)
    }

    if ($this.closest('.js-section-cart').length) {
      updateCartGift(rowsArr, false);
    }
  };
});

/* Header Button Cart */
$doc.on('click', '.js-btn-cart', function(e) {
  if (!$(this).closest('.template-checkout').length) {
    e.preventDefault();
    
    ajaxCart(true);
  };
});

/* Add Gift Wrap */
$doc.on('click', '.js-link-add', function(e) {
  e.preventDefault();
  const $this = $(this);
  const itemId = $this.attr('href');
  let itemQuantity = $this.data('add-quantity');
  const itemGift = $this.data('add-item');
  const $itemsParent = $this.closest('.js-cart-items');
  const $itemGift = $itemsParent.find(`[data-prop='${itemGift}']:not([data-prop-target])`);
  const $itemGiftField = $itemGift.find('.js-qty input');
  const itemGiftQty = $itemGiftField.val();
  const itemGiftMax = $itemGiftField.data('max');
  const $currentRow = $this.closest('[data-row-position]');
  const rowPosition = $currentRow.data('row-position');
  const firstQty = $this.data('add-quantity-first');
  const giftProp = $this.data('gift-prop');
  const giftVal = $this.data('gift-val');
  const productProp = $this.data('gift-product-prop');

  if ((itemGiftQty === undefined && itemGiftMax === undefined) || (itemGiftQty < itemGiftMax)) {
    if (itemGiftQty === undefined && itemGiftMax === undefined) {
      itemQuantity = firstQty;

      $.post('/cart/change.js', {
        quantity: itemQuantity,
        line: rowPosition,
        properties: {
          [giftProp]: giftVal
        }
      }).done(function() {
        $.post('/cart/add.js', {
          quantity: itemQuantity,
          id: itemId,
          properties: {
            [productProp]: itemGift
          }
        }).done(function() {
          if ($this.closest('.js-widget-cart').length) {
            ajaxCart(true);
          } else {
            ajaxCart();
          }
        });
      });
    } else {
      $.post('/cart/add.js', {
        quantity: itemQuantity,
        id: itemId,
        properties: {
          [productProp]: itemGift
        }
      }).done(function() {
        if ($this.closest('.js-widget-cart').length) {
          ajaxCart(true);
        } else {
          ajaxCart();
        }
      });
    }
  };
});



// WEBPACK FOOTER //
// ../assets/js/cart.js